import { useAuth } from "@/contexts/AuthProvider";
import {
  useContextMenu,
  type RowContextMenu,
} from "@/components/hooks/useContextMenu";

interface CatalogCreateMenu {
  /// Spread onto the create pill. `undefined` for users without the
  /// catalog-manager role — the pill then keeps the browser's own context menu
  /// and the catalog option is never rendered for them.
  triggerProps?: RowContextMenu["triggerProps"];
  position: RowContextMenu["position"];
  close: RowContextMenu["close"];
}

/// Right-click (or Shift+F10 / touch-hold) menu for the "New model" / "New
/// dataset" pills, where a catalog manager can create the role-owned catalog
/// variant instead. Wraps the shared row-menu hook so the pill gets the same
/// keyboard and touch openings as every other menu; the role gate lives here so
/// no caller can render the option without it.
export function useCatalogCreateMenu(): CatalogCreateMenu {
  const { canManagePublicCatalog } = useAuth();
  const menu = useContextMenu();

  return {
    triggerProps: canManagePublicCatalog ? menu.triggerProps : undefined,
    // Also gated, so a role revoked while the menu is open closes it.
    position: canManagePublicCatalog ? menu.position : null,
    close: menu.close,
  };
}
